import React from 'react'
import useStyles from './coupon-month-block-style'
import combineClassNames from '../../helpers/combineClassNames'

const CouponMonthBlockView = ({
  children,
  sectionHeaderText,
}) => {
  // styles
  const styles = useStyles()

  return (
    <section className={styles.container}>
      <header
        className={
          combineClassNames([
            styles.header,
          ])
        }
      >
        <h1 className={styles.title}>{sectionHeaderText}</h1>
      </header>
      <div className={styles.contentCointainer}>
        {children}
      </div>
    </section>
  )
}

export default CouponMonthBlockView
